
import Component from '../../../assets/scripts/modules/component';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';

class Button extends Component {
  init() {
    const role = this.element.getAttribute('data-role');

    if (role === 'become-a-friend') {
      this.initBecomeAFriend();
    }
  }

  initBecomeAFriend() {
    const onLinkClick = (event) => {
      event.preventDefault();
      fireCustomEvent('become-a-friend:start');
    };

    this.element.addEventListener('click', onLinkClick);
  }
}

for (const element of document.querySelectorAll('.button[data-role]')) {
  element.instance = new Button('button', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/button/button.js